<div class="network-indicator">
  @if (pusherStatus$ | async; as pusherStatus) {
    <mat-icon
      svgIcon="cm:cloud-sync"
      [ngClass]="pusherStatus === 'connected' ? 'success' : 'error'"
    ></mat-icon>
  }
</div>
